"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confFilterClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var confFilterClick = function (event) {
    var eventData = {
        action: 'apply filter',
        event: analytics_layer_1.LinkInteractionEventNames.ConfFilterClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.ConfFilterClick,
        conf: {
            confClick: event.eventData.conf.confFilter || consts_1.NOT_AVAILABLE,
            confResults: event.eventData.conf.confResults || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.confFilterClick = confFilterClick;
